import {React, useState, useEffect} from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import Loading from "./common/Loading";
import CalculateCalorie from "./components/CalculateCalorie";
import Dietician from "./components/Dietician";
import Home from "./components/Home/Home";
import Packages from "./components/Home/Packages";
import Menu from "./components/Menu";
import Package from "./components/Package";
import MyProfile from "./components/Profile/MyProfile";
import SignUp from "./components/SignUp";
import SingIn from "./components/SingIn";
import SubscribeNow from "./components/SubscribeNow";
import TermsAndConditions from "./components/TermsAndConditions";
import ThankYou from "./common/ThankYou";
import PrivacyPolicy from "./components/PrivacyPolicy";
import PackagesNew from "./components/New/PackagesNew/PackagesNew";
import Account from "./components/New/Account/Account";
import SignInNew from "./components/New/Account/SignIn";
import SignUpNew from "./components/New/Account/SignUp";
import Checkout from "./components/New/Checkout/Checkout";
import Navbar from "./common/Navbar";
import AddAddress from "./components/New/Checkout/AddAddress";
import CalculateCalories from "./components/New/CalculateCalories/CalculateCalories";
import KnowBirthday from "./components/New/CalculateCalories/Section/KnowBirthday";
import KnowGender from "./components/New/CalculateCalories/Section/KnowGender";
import KnowHeight from "./components/New/CalculateCalories/Section/KnowHeight";
import KnowWeight from "./components/New/CalculateCalories/Section/KnowWeight";
import KnowActivity from "./components/New/CalculateCalories/Section/KnowActivity";
import KnowGoal from "./components/New/CalculateCalories/Section/KnowGoal";
import CalculateResult from "./components/New/CalculateCalories/Section/CalculateResult";
import UpdateGoogleMap from "./components/New/GoogleMap/UpdateGoogleMap";

const RoutesPage = () => {
  
  const Refresh = useSelector(state => state.home.Refresh);
  const [render] = useState(localStorage.getItem('user_id'))

  return (
    <Router baseName={'/'}>
      <ToastContainer></ToastContainer>
        {Refresh?<Loading/>:null}
        
        <Navbar />
        <Routes>
         {/* {render?<Route exact path='/myProfile' element={<MyProfile /> }/>:null} */}

          <Route exact path='/' element={<Home/> }/>
          <Route exact path='/PACKAGE/:PackageID' element={<Package/>}/>
          <Route exact path='/PACKAGE/:PackageID/:pricing' element={<Package/>}/>
          {/* <Route exact path='/package' element={<Package/>}/> */}
          <Route exact path='/package' element={<PackagesNew/>} />
          <Route exact path='/account' element={<Account />}/>
          <Route exact path='/account/signup' element={<SignUpNew />}/>
          <Route exact path='/account/signin' element={<SignInNew />}/>
          <Route exact path='/checkout' element={<Checkout />}/>
          <Route exact path='/checkout/update-map' element={<UpdateGoogleMap />}/>
          <Route exact path='/checkout/add-address' element={<AddAddress />}/>
          {/* <Route exact path='/calculate-calorie' element={<CalculateCalorie/>}/> */}
          <Route exact path='/calculate-calorie' element={<CalculateCalories/>}>
            <Route exact path='know-gender' element={<KnowGender />} />
            <Route exact path='know-birthday' element={<KnowBirthday />} />
            <Route exact path='know-height' element={<KnowHeight />} />
            <Route exact path='know-weight' element={<KnowWeight />} />
            <Route exact path='know-activity-level' element={<KnowActivity />} />
            <Route exact path='know-goal' element={<KnowGoal />} />
            <Route exact path='calculate' element={<CalculateResult />} />
          </Route>
          <Route exact path='/dietician' element={<Dietician/>}/>
          <Route exact path='/menu' element={<Menu/>}/>
          <Route exact path='/sign-in' element={<SignInNew/>}/>
          <Route exact path='/sign-up' element={<SignUpNew /> }/>
          {/* <Route exact path='/sign-in' element={<SingIn/>}/>
          <Route exact path='/sign-up' element={<SignUp /> }/> */}
          <Route exact path='/subscribe' element={<SubscribeNow/> }/>
          <Route exact path='/terms-conditions' element={<TermsAndConditions/> }/>
          <Route exact path='/ThankYou' element={<ThankYou/> }/>
          <Route exact path='/privacy-policy' element={<PrivacyPolicy/> }/>
        </Routes>
    </Router>
  );
};

export default RoutesPage;
